import React, { Component } from 'react'
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom'
import { firebase } from './config/firebase'

import './App.css'
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css'
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css'
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css'
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css'
// Import Main styles for this application
import './scss/style.css'

// Containers
import { DefaultLayout } from './containers'
// Pages
import { Login, Page404, Page500, Register } from './views/Pages'
import SignOutPage from './views/Pages/SignOut/SignOutPage'
import Policy from './views/Pages/Login/Policy';

// import { renderRoutes } from 'react-router-config'

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      isAuth: true
    }

  }

  async componentWillMount() {
    this.setState({ isLoading: true })
    await firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ isAuth: true })
      } else {
        this.setState({ isAuth: false })
      }
    })
    this.setState({ isLoading: false })
  }

  render() {
    return !this.state.isLoading ? (
      <HashRouter>
        <Switch>
          <Route
            exact
            path="/login"
            name="Login Page"
            component={Login}
          />
          <Route exact path="/register" name="Register Page" component={Register} />
          <Route exact path="/404" name="Page 404" component={Page404} />
          <Route exact path="/500" name="Page 500" component={Page500} />
          <Route exact path="/policy" name="Policy Page" component={Policy} />
          <Route
            path="/"
            name="Home"
            render={(props) => this.state.isAuth ? <DefaultLayout {...props} /> : <Redirect to='/login' {...props} />}
          //component={this.state.isAuth ? DefaultLayout : null}
          />
          <Route exact path="/logout" name="Sign Out" component={SignOutPage} />
        </Switch>
      </HashRouter>
    ) : null
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js